<template>
<!--  <f7-login-screen :opened="true">-->
<!--        @page:mounted="loadedIntoView('mounted')"-->
<!--        @page:afterin="loadedIntoView('afterin')"-->
    <f7-page
        @page:init="loadedIntoView('init')"
        @page:mounted="loadedIntoView('mounted')"
        id="logout-screen"
    >
      <f7-login-screen-title>
        <img src="/static/images/logos/private-gym/logo-cropped.svg" style="width: 80%; max-width:250px; opacity: 1;" class="m-3 w-80">
        <br/>
        Logout
      </f7-login-screen-title>
    </f7-page>
<!--  </f7-login-screen>-->
</template>

<script>

export default {
  components: {
    //
  },

  props: {
    f7router: Object,
    f7route: Object,
  },

  mixins: [],

  data: function () {
    return {
      //
    };
  },

  computed: {
    current_user_has_token() {
      return this.$store.getters['current_user/token'].length > 0;
    },
  },

  created() {
    //
  },

  mounted() {
    //
  },

  methods: {
    loadedIntoView(type) {
      this.$store.dispatch('current_user/logout').then(response => {
        window.location.href = '/';
      });
    }
  },

  watch: {
    //
  }
};
</script>
